const initialState = {
  // Adding POS Invoice
  isAddingPosInvoice: false,
  addPosInvoiceResult: null,

  // Getting POS Invoices List
  isGettingPosInvoicesList: false,
  posInvoicesList: [],
  posInvoicesTotalResults: 0,

  // Getting Next POS Invoice Number
  isGettingPosInvoiceNumber: false,
  posInvoiceNumber: {},
};

const PosInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    // Adding POS Invoice
    case "ADD_POS_INVOICE_REQUEST":
      return {
        ...state,
        isAddingPosInvoice: true,
      };
    case "ADD_POS_INVOICE_SUCCESS":
      return {
        ...state,
        isAddingPosInvoice: false,
        addPosInvoiceResult: action.payload,
      };
    case "ADD_POS_INVOICE_ERROR":
      return {
        ...state,
        isAddingPosInvoice: false,
      };

    // Getting POS Invoices List
    case "POS_INVOICES_LIST_REQUEST":
      return {
        ...state,
        isGettingPosInvoicesList: true,
      };
    case "POS_INVOICES_LIST_SUCCESS":
      return {
        ...state,
        isGettingPosInvoicesList: false,
        posInvoicesList: action.payload?.data || [],
        posInvoicesTotalResults: action.payload?.totalResults || 0,
      };
    case "POS_INVOICES_LIST_ERROR":
      return {
        ...state,
        isGettingPosInvoicesList: false,
        posInvoicesList: [],
      };

    // Getting Next POS Invoice Number
    case "POS_INVOICE_NUMBER_REQUEST":
      return {
        ...state,
        isGettingPosInvoiceNumber: true,
      };
    case "POS_INVOICE_NUMBER_SUCCESS":
      return {
        ...state,
        isGettingPosInvoiceNumber: false,
        posInvoiceNumber: action.payload,
      };
    case "POS_INVOICE_NUMBER_ERROR":
      return {
        ...state,
        isGettingPosInvoiceNumber: false,
      };

    default:
      return state;
  }
};

export default PosInvoiceReducer;
